import React, { useEffect, useState } from 'react';
import { withAuctionCore } from 'agent';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import useStores from 'hooks/useStore';
import PropTypes from 'prop-types';
import useLocalStorage from 'hooks/useLocalStorage';
import Select from 'react-select';
import {
  Column, Row, Label, CheckWrapper, Title,
} from '../../../routes/Search/styles';
import TextInput from '../../forms/TextInput';

const colors = [
  { label: 'Red', value: 'RED' },
  { label: 'Blue', value: 'BLUE' },
  { label: 'Black', value: 'BLACK' },
  { label: 'Orange', value: 'ORANGE' },
  { label: 'Silver', value: 'SLVR' },
  { label: 'White', value: 'WHT' },
  { label: 'Green', value: 'GREEN' },
  { label: 'Purple', value: 'PURPLE' }];

function camelize(str) {
  return str.toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
}

const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: 'white', marginBottom: 0 }),
  option: (styles, {
    isFocused,
  }) => ({
    ...styles,
    color: 'black',
    textAlign: 'left',
    backgroundColor: isFocused ? '#ccc' : null,
  }),
};

const InspectionOptions = observer(({
  auctioncore,
  mileage,
}) => {
  const { UIStore } = useStores();
  const {
    setLoading, model, externalReferrer, setInspectionOptions, condition, conditionOptions, setProperty,
  } = UIStore;

  const [proConditionOptions, setProConditionOptions] = useLocalStorage('pro_condition_options', '');

  const [tmuChecked, setTmuChecked] = useState(false);
  const handleClick = () => {
    setProperty('mileage', 'TMU');
    setTmuChecked(!tmuChecked);
  };

  useEffect(() => {
    if (model) {
      setLoading(true);
      auctioncore.getInspectionMaster(model)
        .then((res) => {
          const arr = [];

          res.data.inspectionOptions.map((item) => {
            let index = 1;

            if (item.name === 'ENGINE/TRANSMISSION - MECHANICAL' || item.name === 'BODYWORK/PAINT') {
              index = 0;
            }

            arr.push({
              name: item.name,
              rating: item.ratings[index],
            });
          });

          setProperty('conditionOptions', res.data.inspectionOptions);
          setProConditionOptions(res.data.inspectionOptions);
          setProperty('condition', arr);
        })
        .catch((error) => {
          setLoading(false);
          UIStore.setShowError(true, error.message);
        })
        .finally(() => setLoading(false));

      return;
    }

    setInspectionOptions([]);
  }, [model]);

  const updateSelectedInspectionOptions = (key, value) => {
    const _options = condition;

    _options[key] = value;

    const arr = [];

    Object.keys(_options).map((name) => {
      arr.push({ name, value: _options[name] });
    });

    setProperty('condition', arr);
  };

  const groupSize = 2;
  const InspectionRows = conditionOptions.map((content, i) => {
    const input = (
      <div>
        <Label>
          {camelize(content.name.toLowerCase().replace('- mechanical', ''))}
          *
        </Label>
        <Select
          styles={colourStyles}
          placeholder={camelize(content.name.toLowerCase())}
          isSearchable={false}
          defaultValue={externalReferrer ? { label: content.ratings[1], value: content.ratings[1].toUpperCase() } : null}
          onChange={(e) => updateSelectedInspectionOptions(content.name, e.value)}
          options={content.ratings.map((item) => ({
            label: camelize(item.toLowerCase()),
            value: item,
          }))}
        />
      </div>
    );

    return <Column right={i % 2 !== 0} left={i % 2 === 0}>{input}</Column>;
  }).reduce((r, element, index) => {
    index % groupSize === 0 && r.push([]);
    r[r.length - 1].push(element);
    return r;
  }, []).map((rowContent, i) => <Row key={`row_${i}`}>{rowContent}</Row>);

  useEffect(() => {
    if (conditionOptions.length > 0 && externalReferrer) {
      conditionOptions.map((item) => {
        updateSelectedInspectionOptions(item.name, item.ratings[1]);
      });
    }
  }, [externalReferrer, conditionOptions]);

  if (!model || !conditionOptions) {
    return null;
  }

  const handleOnChange = (e) => {
    const re = /^[0-9/b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      setProperty('mileage', e.target.value);
    }
  };

  return (
    <div>
      {conditionOptions.length > 0 && (
        <Row>
          <Column>
            <Title>Mileage*</Title>
            <TextInput type="number" defaultValue={mileage} onChange={(e) => setProperty('mileage', !Number.isInteger(e.target.value) ? e.target.value.toUpperCase() : e.target.value )} noMargin disabled={tmuChecked} />
            <CheckWrapper>
              True Mileage Unknown
              <input type="checkbox" onClick={handleClick} checked={tmuChecked} />
            </CheckWrapper>

          </Column>
          <Column>
            <Title>Color</Title>
            <Select
              isSearchable={false}
              styles={colourStyles}
              placeholder="Color"
                // onChange={(e) => updateSelectedInspectionOptions(content.name, e.value)}
              options={colors}
            />
          </Column>
        </Row>
      )}
    </div>
  );
});

InspectionOptions.propTypes = {
  model: PropTypes.string,
  auctioncore: PropTypes.object.isRequired,
  selectedInspectionOptions: PropTypes.array.isRequired,
  setSelectedInspectionOptions: PropTypes.func.isRequired,
};

InspectionOptions.defaultProps = {
  model: null,
};

export default withAuctionCore(InspectionOptions);
